module.exports = __webpack_public_path__ + "assets/img/2.6708d506.jpg";